// src/components/proces_verbal/Create.jsx
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Container, Alert } from "react-bootstrap";
import { toast } from "react-toastify";
import { authFetch } from "../utils/authFetch";
import { NirForm, useEmptyNir } from "../nir/Form";

export default function ProcesVerbalCreate() {
  const navigate = useNavigate();
  const [form, setForm] = useState(useEmptyNir());
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");

  const save = async () => {
    setSaving(true);
    setError("");
    try {
      const res = await authFetch("/proces-verbal/", {
        method: "POST",
        body: JSON.stringify(form),
      });
      toast.success("Procesul verbal a fost creat cu succes!");
      if (res?.id) navigate(`/proces-verbal/${res.id}/edit`);
      else throw new Error("Răspuns invalid la creare Proces verbal");
    } catch (e) {
      setError(String(e.message || e));
      toast.error(`Eroare la salvare: ${e.message || e}`);
    } finally {
      setSaving(false);
    }
  };

  return (
    <Container className="py-3">
      <h3 className="mb-3">Proces verbal — creare</h3>
      {error && <Alert variant="danger">{error}</Alert>}
      <NirForm
        value={form}
        onChange={setForm}
        onSubmit={save}
        submitting={saving}
      />
    </Container>
  );
}
